import React from "react";
import "./footer.css";

const FooterScreen = () => {
	return (
		<footer className=" pt-4 pb-2 footer-box text-white text-center flex items-center justify-center">
			<h1 className="text-white fs-6 text-lowercase">
				All right reserves 2022
			</h1>
		</footer>
	);
};

export default FooterScreen;
